// extracted by mini-css-extract-plugin
export default {"modal-content":"RDPModal-module__modal-content__czZ5z"};